<template>
    <BaseWidget
        :id="id"
        :widget-name="widgetName"
        :has-content="!!content"
        :is-loading="isLoading"
        :is-expanded="isExpanded"
        :configuration-data="configurationData"
        :widget-type="widgetType"
        :widget-last-updated="widgetLastUpdated"
        :needs-attention="needsAttention"
        v-on="$listeners"
    >
        <div v-show="!isLoading" class="widget-content">
            <div class="widget-inner">
                <div class="pie-chart-wrapper system-activity-pie-chart">
                    <div ref="widgetChartRef" class="doughnut-chart-1"></div>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script type="text/babel">
import { mapState, mapGetters } from 'vuex';
import Chartist from 'ascom-chartist-logscale';
import BaseWidget from '../BaseWidget';
import { getClassNameByCategoryId } from '../widgetChartHelpers';
import widgetInterface from './common/widgetInterface';
import WidgetConfigurationTable from './common/WidgetConfigurationTable.vue';
import { mounted, beforeDestroy } from './common/chartsLifecycleHooks';
import { initDoughnutChart, makeChart } from './common/chartingHelpers';
import { configurationData } from './common/widgetsComputedProps';

export default {
    components: {
        BaseWidget,
        WidgetConfigurationTable,
    },

    props: widgetInterface,

    data() {
        return {
            instanceDoughnutChart: null,
            needsAttention: false,
        };
    },

    computed: {
        ...mapGetters('user', ['userType']),
        ...mapState({
            navCollapsed: 'navCollapsed',
            callTypes: 'callTypes',
            allAssignmentAreas: 'assignmentArea',
        }),

        configurationData,

        /**
         * Returns widget name
         * @returns {string}
         */
        widgetName() {
            return this.configuration.name || this.$t('dashboard.widgetType1.name');
        },

        /**
         * Prepares data for Chartist
         * @returns {Array}
         */
        chartData() {
            if (!this.content) {
                return [];
            }

            return this.callTypes.map(callType => ({
                meta: callType.name,
                value: this.content.find(e => e.call_type === callType.id).quantity,
                className: getClassNameByCategoryId(callType.id),
            }));
        },
    },

    mounted,

    beforeDestroy,

    methods: {
        makeChart,

        drawChart(ref, data) {
            let options = initDoughnutChart(data, this.isExpanded, this.isPrintver);
            if (this.instanceDoughnutChart) {
                this.instanceDoughnutChart.update({ series: data }, options);
            } else {
                this.instanceDoughnutChart = new Chartist.Pie(ref, { series: data }, options);
            }
        },

        setNeedsAttention(value) {
            this.needsAttention = value;
        },
    },
};
</script>
